















































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Icon from './generic/Icon.vue';
import GatewaysList from './gateways/sources/GatewaysList.vue';
import SourceAuthenticate from './gateways/sources/Authenticate.vue';
import Steps3 from './generic/steps/Steps3.vue';
import { getModule } from 'vuex-module-decorators';
import MainModule from '../store/modules/MainModule';
import { User } from 'ganttlab-entities';
import LocalForage, {
  getRememberedSource,
  getRememberedCredentials,
} from '../helpers/LocalForage';
import { trackVirtualpageView, trackInteractionEvent } from '../helpers/GTM';

const mainState = getModule(MainModule);

@Component({
  components: {
    Icon,
    GatewaysList,
    SourceAuthenticate,
    Steps3,
  },
})
export default class Welcome extends Vue {
  source: string | null = null;
  authenticating = false;
  authenticated = false;

  @Prop({ type: Boolean, default: false }) readonly justLoggedOut!: boolean;

  async created() {
    // when created, fill vuex store with remembered data
    // created hook is executed synchronously! here we don't actually care
    // that vuex is filled later, on resolve
    mainState.setCredentialsBySource(await getRememberedCredentials());
    mainState.setRemember(await LocalForage.getItem('remember'));
  }

  mounted() {
    this.$nextTick(async () => {
      if (!this.justLoggedOut) {
        this.source = await getRememberedSource();
      }
    });
    trackVirtualpageView('Welcome', '/welcome');
  }

  signingIn() {
    trackInteractionEvent(
      'Authentication',
      'Authenticating',
      this.source ? this.source : undefined,
    );
    this.authenticating = true;
  }

  signinError() {
    trackInteractionEvent(
      'Authentication',
      'Error authenticating',
      this.source ? this.source : undefined,
    );
    this.authenticating = false;
  }

  setSource(source: string) {
    trackInteractionEvent('Authentication', 'Selected Source', source);
    this.source = source;
  }

  forceStep(step: number) {
    if (step === 1) {
      trackInteractionEvent(
        'Authentication',
        'Back to list',
        this.source ? this.source : undefined,
      );
      this.source = null;
    }
  }

  get currentStep(): number {
    if (this.source === null) return 1;
    if (this.authenticating === false) return 2;
    if (this.authenticated === true) return 4;
    return 3;
  }

  get user(): User | null {
    return mainState.user;
  }

  @Watch('user')
  onUserChange(user: User | null) {
    if (user) {
      this.authenticated = true;
    }
  }

  goToReadMore() {
    trackInteractionEvent('Click', 'Read more');
  }

  goToAuthor() {
    trackInteractionEvent('Click', 'Author');
  }

  goToContribute() {
    trackInteractionEvent('Click', 'Contribute');
  }

  goToTwitter() {
    trackInteractionEvent('Click', 'Twitter');
  }

  goToPrivacy() {
    trackInteractionEvent('Click', 'Privacy');
  }
}
